import React,{ Component } from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Divider from '@material-ui/core/Divider';
import { getPlanAction } from '../../Actions/paymentAction';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import CardForm from './cardDetails';
import moment from 'moment';
import Logo from '../../Helper/Logo/logo';
import { logoutAction } from '../../Actions/index';

const styles= theme =>({
    grid:{
        width:'50%',
        padding: '20px 20px',
        margin:'0 auto',
        backgroundColor:'#fff',
        border:'1px solid #ddd'
    },
    paper:{
        padding: 10,
        borderRadius:0
    },
    planPaper:{
        padding: 10,
        borderRadius:0,
        border:'4px solid #ddd',
        boxShadow:'none',
    },
    selectedPlanPaper:{
        padding: 10,
        borderRadius:0,
        border:'4px solid #b764ac',
        boxShadow:'none'
    },
    containerGrid:{
        '& > $totalGrid':{
            paddingBottom:0
        },
        '& > $pointGrid':{
            paddingTop:0
        }
    },
    pointGrid:{
        paddingTop:0
    },
    totalGrid:{
        paddingBottom:0
    }
});

class Payment extends Component{
    constructor(props){
        super(props);
        this.state={
            expanded: null,
            selectedPlan:{}
        }
    }

    componentDidMount(){
        this.props.getPlanAction().then((data)=>{
           // debugger;
            if(data.ResponseCode){
                this.setState({
                    selectedPlan:data.Plans[0]
                })
            }
        });
    }

    handleChange = panel => (event, expanded) => {
        this.setState({
            expanded: expanded ? panel : false,
        });
    };

    handlePlanClick=(selectedPlan)=>()=>{
        this.setState({
            selectedPlan
        });
    };

    render(){
        const { classes, plans, user ,history :{ location : { state : { withTrial = "" }= "" } } } = this.props;

        const { expanded,selectedPlan } = this.state;
        return(
            <div style={{padding: '50px 0px 50px 0px'}}>
                <Grid item sm={12} xs={12} style={{textAlign:'center'}}>
                    <span className="logo-logout" onClick={()=>this.props.logoutAction()}><Logo /></span>
                </Grid>
            <Grid className="grid-header" container>
                    <Grid item container style={{ boxShadow: '0 0 0 1px rgba(0,0,0,0.1), 0 2px 3px rgba(0,0,0,0.2)' }}>
                        <Grid item sm={4} xs={12} style={{backgroundColor:'#851679',padding:'30px 20px'}}>
                            <div className='product-header'>Select Subscription</div>
                        </Grid>
                        <Grid item sm={8} xs={12} style={{backgroundColor:'#fff',padding:'30px 20px'}}>
                            <div className='product-description'>{'Start Your Free One Month Trial Now!'}</div>
                            <div className='title-description'>{'You will not be charged until your second month starts. Cancel anytime.'}</div>
                        </Grid>
                    </Grid>
                    <Grid container  style={{ margin: '20px 0' }}>
                        <Grid item className='index-number'>
                            <span className="step-number">1</span>
                        </Grid>
                        <Grid item className='index-number-text-paymentinfo'>
                            <div className="section-header">
                                <label>Confirm Your Billing Cycle</label>
                            </div>
                        </Grid>
                    </Grid>
                    <Grid container spacing={24} className={classes.containerGrid}>
                        {
                            plans.Plans.map((plan)=>{
                                return(
                                    <Grid item xs={12} sm={12} md={3}>
                                        <div className="plans-wrapper">
                                        <Paper className={(selectedPlan.PlanID===plan.PlanID)?classes.selectedPlanPaper:classes.planPaper} onClick={this.handlePlanClick(plan)}>
                                            <p className="plan-title"><strong>{plan.PlanTitle && (plan.PlanTitle).split('P')[0] }</strong></p>
                                            <p className="month-free">1st Month FREE</p>
                                            {plan.PlanTitle.includes('1 Month') ?
                                                <p className="price-description"><br/>Then ${plan.PlanAmount} / each month</p>
                                                :
                                                <p className="price-description"><br/>Then ${plan.PlanAmount} / every {((plan.PlanTitle.split('M')[0]).trim())} months</p>
                                            }
                                            {plan.PlanTitle.includes('1 Month') ?
                                                <p className="plan-description"><br/></p>
                                                :
                                                <p className="plan-description">{"(" + (plan.PlanDescription) + ")"}</p>
                                            }
                                        </Paper>
                                        </div>
                                    </Grid>
                                )
                            })
                        }

                        <Grid item xs={12} className={classes.totalGrid}>
                            <Paper className={classes.paper} style={{ padding: '16px 16px 0' }}>
                                <div>
                                    <Grid container>
                                        <Grid item xs={10}>
                                            {selectedPlan.PlanTitle && selectedPlan.PlanTitle.includes('1 Month') ?
                                                <p style={{minHeight: '30px', margin: '0'}}>You will be charged amount shown each month after your free trial ends.</p>
                                                :
                                                <p style={{minHeight: '30px', margin: '0'}}>You will be charged amount shown every {selectedPlan.PlanTitle && ((selectedPlan.PlanTitle.split('M')[0]).trim())} months after your free trial ends.</p>
                                            }

                                        </Grid>
                                        <Grid item xs={2} className="text-right">
                                            <p style={{ minHeight: '30px', margin: '0', paddingRight: '15px' }}>${selectedPlan.PlanAmount}</p>
                                        </Grid>
                                    </Grid>
                                </div>
                            <Divider/>
                                <div>
                                    <Grid container>
                                        <Grid item xs={10}>
                                            <p style={{ minHeight: '40px', margin: '10px 0 0', fontWeight: 'bold' }}>Today's Total</p>
                                        </Grid>
                                        <Grid item xs={2} className="text-right">
                                            <p style={{ minHeight: '40px', margin: '10px 0 0', paddingRight: '15px', fontWeight: 'bold' }}>$0</p>
                                        </Grid>

                                    </Grid>
                                </div>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} className={classes.pointGrid}>
                        <div style={{backgroundColor:'#ddd', padding: '8px 16px'}}>
                          {
                            <ul style={{ margin: 0 }}>
                            <li>1. Your free trial begins today and ends on {moment().add(30,'days').format('MMMM DD,YYYY')}. </li>
                            {selectedPlan.PlanTitle && selectedPlan.PlanTitle.includes('1 Month') ?
                                <li>2. Beginning {moment().add(30,'days').format('MMMM DD,YYYY')}, your payment method will be charged ${selectedPlan.PlanAmount} each month.</li>
                                :
                                <li>2. Beginning {moment().add(30,'days').format('MMMM DD,YYYY')}, your payment method will be charged ${selectedPlan.PlanAmount} every {selectedPlan.PlanTitle && ((selectedPlan.PlanTitle.split('M')[0]).trim()) } months.</li>
                            }
                            {selectedPlan.PlanTitle && selectedPlan.PlanTitle.includes('1 Month') ?
                                <li>3. The plan will automatically renew each month until cancelled. To avoid charges, cancel before the renewal date.</li>
                                :
                                <li>3. The plan will automatically renew every {selectedPlan.PlanTitle && ((selectedPlan.PlanTitle.split('M')[0]).trim()) } months until cancelled. To avoid charges, cancel before the renewal date.</li>
                            }
                            </ul>}
                        </div>
                        </Grid>
                    </Grid>
                    <Grid container justify={'center'} style={{ margin: '20px 0' }}>
                        <Grid item style={{ width: '6%' }}>
                            <span className="step-number">2</span>
                        </Grid>
                        <Grid item style={{ width: '94%' }}>
                            <div className="section-header">
                                <label>Select Your Payment Method</label>
                            </div>
                        </Grid>
                    </Grid>
                <Grid container spacing={24}>
                    <Grid item sm={12}>
                    <ExpansionPanel expanded={expanded === 1} onChange={this.handleChange(1)}>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} style={{ backgroundColor: '#ddd', fontWeight: 'bold', fontSize: 'larger'}}>
                            <div>Credit Card <img src={require('../../images/payment-cards/Visa.png')} style={{background:'transparent'}} width={50} height={30}/>
                            <img src={require('../../images/payment-cards/americanexpress.png')} style={{background:'transparent'}} width={50} height={30}/>
                            <img src={require('../../images/payment-cards/Discover.png')} style={{background:'transparent'}} width={50} height={30}/>
                            <img src={require('../../images/payment-cards/master.png')} style={{background:'transparent'}} width={50} height={30}/></div>

                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <CardForm plan={selectedPlan} Business={user.results}  history={this.props.history}/>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                    </Grid>
                </Grid>
                </Grid>
            </div>
        )
    }
}
const mapStateToProps=(state)=> {
    return {
        plans:state.plans,
        user:state.loginResponse
    }
};
const matchDispatchToProps=(dispatch)=> {
    return bindActionCreators({
        getPlanAction,logoutAction
    },dispatch)
};
export default connect(mapStateToProps,matchDispatchToProps)(withStyles(styles)(Payment));